import app from 'flarum/forum/app';
import Extend from 'flarum/common/extenders';
import IndexPage from 'flarum/forum/components/IndexPage';
import TagView from './components/TagView';
import TagViewPC from './components/TagViewPC';
import TagsPage from 'flarum/tags/components/TagsPage';
import SearchView from './components/SearchView';
import HomePage from './components/HomePage';


export default [
  new Extend.Routes()
  .add('tags', '/tags', TagsPage)
  .add('tag', '/tag/:tags', 'ontouchstart' in window && window.innerWidth <768 ?  TagView : TagViewPC)
  .add('tag.type', '/tag/:tags/:type', 'ontouchstart' in window && window.innerWidth <768 ?  TagView : TagViewPC)
  .helper('tag', (tag) => app.route('tag', { tags: tag.slug() }))
  // .add('pages.home', '/', HomePage)
  // .helper('pages.home', () => app.route('pages.home', { sort: 'front' }))
  
];

